/**
 * Created by EugeneU on 22.10.2015.
 */

export const name: string = 'Gauge';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-gauge';
export const icon: string = 'dashboard';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-gauge'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)

//export const priority: number = 1;
